import { render, staticRenderFns } from "./mergePools.vue?vue&type=template&id=23ce51cd&scoped=true"
import script from "./mergePools.vue?vue&type=script&lang=ts"
export * from "./mergePools.vue?vue&type=script&lang=ts"
import style0 from "./mergePools.vue?vue&type=style&index=0&id=23ce51cd&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ce51cd",
  null
  
)

export default component.exports